import { render, staticRenderFns } from "./UIDateTable.vue?vue&type=template&id=79626a40"
import script from "./UIDateTable.vue?vue&type=script&lang=js"
export * from "./UIDateTable.vue?vue&type=script&lang=js"
import style0 from "./UIDateTable.vue?vue&type=style&index=0&id=79626a40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports